import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ceil',
})
export class CeilPipe implements PipeTransform {
  public transform(value: number): unknown {
    return Math.ceil(value) || 0;
  }
}
